// extracted by mini-css-extract-plugin
export default {"card":"AdminCard_card__nlTjj","card_box":"AdminCard_card_box__7nCzT"};